import React from 'react';


class Spinner extends React.Component {
  render() {
    return (
      <div className="sbm-spinner">
        <div className="sbm-spinner__first"></div>
        <div className="sbm-spinner__second"></div>
        <div className="sbm-spinner__third"></div>
        <div className="sbm-spinner__fourth"></div>
      </div>
    );
  }
}

export default Spinner;

